import { Inject, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ConfigService {
    hostAddress: string;

    constructor(@Inject('BASE_URL') baseUrl: string) {
        this.hostAddress = baseUrl;
    }
}
